import React, { useEffect } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import exporting from 'highcharts/modules/exporting';
import exportData from 'highcharts/modules/export-data';

const HighChartBar = ({ chartData, chartName,xAxis,yAxis}) => {
  exporting(Highcharts);
  exportData(Highcharts);

  // Data Structure
  // const defaultData = [
  //   {
  //     name: "Violence Against Children",
  //     value: 29
  //   },
  //   {
  //     name: "Harassment",
  //     value: 70
  //   },
  //   {
  //     name: "Torture",
  //     value: 89
  //   },
   
  // ];

  const defaultData =[]

  let sortedData = chartData && chartData.length > 0 ? chartData.sort((a,b)=>b.value-a.value) : defaultData.sort((a,b)=>b.value-a.value);
  

    const barOptions = {
      chart: {
        type: 'bar',
      },
      title: {
        text: chartName || 'Incidents Per Issue Categories',
      },
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
      },
      colors: ['#41A6D7', '#1E4376', '#E85E3F'],
      xAxis: {
        title: {
          text: xAxis || "Isues Categories",
        },
        categories: sortedData.map((item) => item.name),
      },
      yAxis: {
        title: {
          text: yAxis || '# of Incidents',
        },
      },
      series: [
        {
          name: 'Incidents',
          data: sortedData.map((item) => item.value),
        },
      ],
    };

   

  return (
    <HighchartsReact
      highcharts={Highcharts}
      options={barOptions}
    />
  );
};

export default HighChartBar;
